[
  {
    "id": "chapter:3a",
    "q": "To prevent a fatigue-related crash while driving:",
    "answer": {
      "text": "Find a safe parking area to take a 15 to 20-minute nap",
      "section": 3,
      "topic": "Fatigue",
      "page": 21
    },
    "otherChoices": [
      "Continue driving so you will reach your destination sooner",
      "Drive late at night when there are not as many users on the roadway"
    ],
    "generated": null,
    "batch": "baseline-chapter",
    "version": 2,
    "updatedAt": "2026-04-29",
    "status": "verified"
  },
  {
    "id": "chapter:3b",
    "q": "If you are driving and you need to use your cell phone, it is best to:",
    "answer": {
      "text": "Stop in a safe parking area and then make the call",
      "section": 3,
      "topic": "Distractions",
      "page": 22
    },
    "otherChoices": [
      "Carefully use your cell phone, but do not talk for a long time",
      "Use a hands-free device so you can keep both hands on the steering wheel"
    ],
    "generated": null,
    "batch": "baseline-chapter",
    "version": 2,
    "updatedAt": "2026-04-29",
    "status": "verified"
  },
  {
    "id": "chapter:3c",
    "q": "If you are over _____ blood alcohol concentration (BAC), you are in violation of the law.",
    "answer": {
      "text": ".08",
      "section": 3,
      "topic": "Alcohol and the Law",
      "page": 23
    },
    "otherChoices": [".10", ".04"],
    "generated": null,
    "batch": "baseline-chapter",
    "version": 2,
    "updatedAt": "2026-04-29",
    "status": "verified"
  },
  {
    "id": "authored:s3-vision-test-standard",
    "q": "The vision test measures that you have at least:",
    "answer": {
      "text": "20/40 vision in at least one eye, with or without corrective lenses",
      "section": 3,
      "topic": "Vision",
      "page": 20
    },
    "otherChoices": [
      "20/20 vision in both eyes, without corrective lenses",
      "20/60 vision in at least one eye, with or without corrective lenses"
    ],
    "generated": null,
    "batch": "review-20260604",
    "version": 1,
    "updatedAt": "2026-06-04",
    "status": "verified"
  },
  {
    "id": "authored:s3-implied-consent-refusal",
    "q": "If you refuse to take a BAC test when asked by a police officer, you can lose your Driver’s License for:",
    "answer": {
      "text": "One year",
      "section": 3,
      "topic": "Alcohol, Other Drugs and Driving",
      "page": 24
    },
    "otherChoices": ["48 hours", "30 days"],
    "generated": null,
    "batch": "review-20260604",
    "version": 1,
    "updatedAt": "2026-06-04",
    "status": "verified"
  },
  {
    "id": "authored:s3-most-important-sense",
    "q": "The most important sense you use in driving is:",
    "answer": {
      "text": "Vision",
      "section": 3,
      "topic": "Effects of Alcohol and other Impairing Drugs",
      "page": 23
    },
    "otherChoices": ["Judgment", "Reaction time"],
    "generated": null,
    "batch": "expansion-r1-20260729",
    "version": 1,
    "updatedAt": "2026-07-29",
    "status": "verified"
  },
  {
    "id": "authored:s3-alcohol-removal-time",
    "q": "The only medically proven method to remove alcohol or other drug combinations from the circulatory system is:",
    "answer": {
      "text": "Time",
      "section": 3,
      "topic": "Alcohol",
      "page": 23
    },
    "otherChoices": ["Coffee or eating", "Fresh air or a cold shower"],
    "generated": null,
    "batch": "expansion-r2-20260729",
    "version": 1,
    "updatedAt": "2026-07-29",
    "status": "verified"
  },
  {
    "id": "authored:s3-under-21-bac",
    "q": "In Kansas, if you are under 21, you can be arrested for alcohol impairment at a BAC as low as:",
    "answer": {
      "text": ".02",
      "section": 3,
      "topic": "Alcohol and the Law",
      "page": 23
    },
    "otherChoices": [".08", ".04"],
    "generated": null,
    "batch": "expansion-r3-20260731",
    "version": 3,
    "updatedAt": "2026-07-31",
    "status": "verified"
  },
  {
    "id": "authored:s3-one-drink-one-hour",
    "q": "About how long does it take the body to get rid of one normal drink from the circulatory system?",
    "answer": {
      "text": "About an hour",
      "section": 3,
      "topic": "Alcohol",
      "page": 23
    },
    "otherChoices": ["About four hours", "About 15 to 20 minutes"],
    "generated": null,
    "batch": "expansion-r3-20260731",
    "version": 2,
    "updatedAt": "2026-07-31",
    "status": "verified"
  },
  {
    "id": "authored:s3-fatigue-prevention-sleep",
    "q": "The best way to prevent fatigue is:",
    "answer": {
      "text": "Sleep",
      "section": 3,
      "topic": "Fatigue",
      "page": 21
    },
    "otherChoices": [
      "Consuming caffeine, such as the equivalent of 2 cups of coffee",
      "Turning up the radio or rolling down the window to wake yourself up"
    ],
    "generated": null,
    "batch": "expansion-r4-20260801",
    "version": 1,
    "updatedAt": "2026-08-01",
    "status": "verified"
  },
  {
    "id": "authored:s3-alcohol-fatal-crashes",
    "q": "Alcohol and other impairing drugs are involved in approximately _____ of all fatal crashes.",
    "answer": {
      "text": "40%",
      "section": 3,
      "topic": "Alcohol, Other Drugs and Driving",
      "page": 22
    },
    "otherChoices": ["70%", "80%"],
    "generated": null,
    "batch": "expansion-r4-20260801",
    "version": 2,
    "updatedAt": "2026-08-02",
    "status": "verified"
  },
  {
    "id": "authored:s3-over-the-counter-drugs",
    "q": "Over-the-counter drugs taken for headaches, colds, hay fever or other allergies:",
    "answer": {
      "text": "Can make you drowsy and affect your driving",
      "section": 3,
      "topic": "Over-the-Counter Drugs",
      "page": 24
    },
    "otherChoices": [
      "Cannot affect driving because they are sold without a prescription",
      "Only affect your driving when combined with alcohol"
    ],
    "generated": null,
    "batch": "expansion-r5-20260801",
    "version": 1,
    "updatedAt": "2026-08-01",
    "status": "verified"
  },
  {
    "id": "authored:s3-late-night-driving-hours",
    "q": "To prevent a fatigue-related crash, try not to drive late at night between the hours of:",
    "answer": {
      "text": "Midnight and 6 a.m.",
      "section": 3,
      "topic": "Fatigue",
      "page": 21
    },
    "otherChoices": ["9 p.m. and 5 a.m.", "Dusk and dawn"],
    "generated": null,
    "batch": "expansion-r5-20260801",
    "version": 1,
    "updatedAt": "2026-08-01",
    "status": "verified"
  },
  {
    "id": "authored:s3-implied-consent-principle",
    "q": "Kansas implied consent law (K.S.A. 8-1001) is based on the principle that when you get your Driver's License:",
    "answer": {
      "text": "You have implicitly consented to a lawfully requested test to determine the alcohol content of blood, breath, urine, or other bodily substance",
      "section": 3,
      "topic": "Alcohol and the Law",
      "page": 24
    },
    "otherChoices": ["You may refuse a BAC test without penalty", "You have consented only to breath testing"],
    "generated": null,
    "batch": "expansion-r6-20260801",
    "version": 1,
    "updatedAt": "2026-08-01",
    "status": "verified"
  },
  {
    "id": "authored:s3-trip-break-schedule",
    "q": "Before a long trip, to maintain alertness you should schedule proper breaks about every:",
    "answer": {
      "text": "100 miles or 2 hours",
      "section": 3,
      "topic": "Fatigue",
      "page": 21
    },
    "otherChoices": ["300 miles", "30 minutes"],
    "generated": null,
    "batch": "expansion-r6-20260801",
    "version": 2,
    "updatedAt": "2026-08-03",
    "status": "verified"
  }
]
